import Vue from 'vue'
import VueRouter from 'vue-router'
import { rawGet } from '../utils/storage'
import { hasPermission, getVisibleMenus } from '../utils/permission'
import Login from '../views/Login.vue'
import NotFound from '../views/NotFound.vue'
import Layout from '../components/Layout.vue'
import Home from '../views/Home.vue'
import EmployeeSelect from '../views/EmployeeSelect.vue'
import Evaluation from '../views/Evaluation.vue'
import EvaluationReport from '../views/EvaluationReport.vue'
import Dashboard from '../views/Dashboard.vue'
import FeatureCorrection from '../views/FeatureCorrection.vue'
import ABCompare from '../views/ABCompare.vue'
import SurveyCreate from '../views/SurveyCreate.vue'
import SurveyFill from '../views/SurveyFill.vue'
import BehaviorManage from '../views/admin/BehaviorManage.vue'
import EmployeeManage from '../views/admin/EmployeeManage.vue'
import EvaluationManage from '../views/admin/EvaluationManage.vue'
import SurveyManage from '../views/admin/SurveyManage.vue'
import AdminDashboard from '../views/admin/AdminDashboard.vue'
// Phase 7 新增模块（占位，后续开发）
import ContentManage from '../views/admin/ContentManage.vue'
import AdminManage from '../views/admin/AdminManage.vue'
import ConfigCenter from '../views/admin/ConfigCenter.vue'
import TaskManage from '../views/admin/TaskManage.vue'
import SurveyTemplateManage from '../views/admin/SurveyTemplateManage.vue'
import FeedbackSurveyManage from '../views/admin/FeedbackSurveyManage.vue'
import AIReportConfig from '../views/admin/AIReportConfig.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/login', component: Login },
  { path: '/survey/:token', component: SurveyFill },
  {
    path: '/',
    component: Layout,
    children: [
      { path: '', component: Home },
      { path: 'select', component: EmployeeSelect, meta: { managerOnly: true } },
      { path: 'evaluation/:id', component: Evaluation, meta: { managerOnly: true } },
      { path: 'report/:id', component: EvaluationReport, meta: { managerOnly: true } },
      { path: 'dashboard', component: Dashboard, meta: { managerOnly: true } },
      { path: 'correction', component: FeatureCorrection, meta: { managerOnly: true } },
      { path: 'ab-compare', component: ABCompare, meta: { managerOnly: true } },
      { path: 'survey-create', component: SurveyCreate, meta: { managerOnly: true } },
      // 平台层路由
      { path: 'admin/admins', component: AdminManage, meta: { adminOnly: true, permission: 'admin:manage' } },
      { path: 'admin/tasks', component: TaskManage, meta: { adminOnly: true, permission: 'task:manage' } },
      // 人员与组织
      { path: 'admin/employees', component: EmployeeManage, meta: { adminOnly: true, permission: 'employee:view' } },
      // 评估体系
      { path: 'admin/behaviors', component: BehaviorManage, meta: { adminOnly: true, permission: 'behavior:view' } },
      { path: 'admin/config', component: ConfigCenter, meta: { adminOnly: true } },
      { path: 'admin/evaluations', component: EvaluationManage, meta: { adminOnly: true, permission: 'evaluation:view' } },
      // 内容素材库
      // 报告模板配置
      { path: 'admin/contents', component: ContentManage, meta: { adminOnly: true, permission: 'content:view' } },
      { path: 'admin/ai-report', component: AIReportConfig, meta: { adminOnly: true } },
      // 数据回收
      { path: 'admin/departure-survey', component: FeedbackSurveyManage, meta: { adminOnly: true, permission: 'departure_feedback:view' } },
      { path: 'admin/surveys', component: SurveyManage, meta: { adminOnly: true, permission: 'survey:view' } },
      // 任务层路由：复用相同组件，URL 带 taskId
      { path: 'admin/tasks/:taskId/employees', component: EmployeeManage, meta: { adminOnly: true, permission: 'employee:view', taskLayer: true } },
      { path: 'admin/tasks/:taskId/behaviors', component: BehaviorManage, meta: { adminOnly: true, permission: 'behavior:view', taskLayer: true } },
      { path: 'admin/tasks/:taskId/config', component: ConfigCenter, meta: { adminOnly: true, taskLayer: true } },
      { path: 'admin/tasks/:taskId/evaluations', component: EvaluationManage, meta: { adminOnly: true, permission: 'evaluation:view', taskLayer: true } },
      { path: 'admin/tasks/:taskId/contents', component: ContentManage, meta: { adminOnly: true, permission: 'content:view', taskLayer: true } },
      { path: 'admin/tasks/:taskId/ai-report', component: AIReportConfig, meta: { adminOnly: true, taskLayer: true } },
      { path: 'admin/tasks/:taskId/departure-survey', component: FeedbackSurveyManage, meta: { adminOnly: true, permission: 'departure_feedback:view', taskLayer: true } },
      { path: 'admin/tasks/:taskId/surveys', component: SurveyManage, meta: { adminOnly: true, permission: 'survey:view', taskLayer: true } },
      // 任务层路由：数据总览
      { path: 'admin/tasks/:taskId/dashboard', component: AdminDashboard, meta: { adminOnly: true, taskLayer: true } },
      { path: 'admin/settings', redirect: '/admin/config?tab=scoring' },
      { path: 'admin/instructions', redirect: '/admin/config?tab=instruction' },
      { path: 'admin/config-instruction', redirect: '/admin/config?tab=instruction' },
      // 任务层配置子路由重定向
      { path: 'admin/tasks/:taskId/config-instruction', redirect: to => ({ path: `/admin/tasks/${to.params.taskId}/config`, query: { tab: 'instruction' } }) },
      { path: 'admin/tasks/:taskId/config-scoring', redirect: to => ({ path: `/admin/tasks/${to.params.taskId}/config`, query: { tab: 'scoring' } }) }
    ]
  },
  { path: '*', component: NotFound }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 旧任务层路由 → 新路由映射
const legacyTaskRouteMap = {
  '/admin/employees': 'employees',
  '/admin/behaviors': 'behaviors',
  '/admin/config': 'config',
  '/admin/evaluations': 'evaluations',
  '/admin/contents': 'contents',
  '/admin/surveys': 'surveys'
}

router.beforeEach((to, from, next) => {
  try {
    // 优先从 store 读取角色（避免 localStorage 被污染）
    const store = router.app && router.app.$store
    let role = ''
    if (store && store.state.user && store.state.user.role) {
      role = store.state.user.role
    } else {
      role = rawGet('role')
    }

    // 未登录且非登录页/问卷页 → 跳转登录
    if (to.path !== '/login' && !to.path.startsWith('/survey/') && !role) {
      next('/login')
      return
    }

    // 已登录角色权限控制
    if (role) {
      const store = router.app && router.app.$store

      // 管理员访问首页：自动重定向到后台任务列表
      if (to.path === '/' && role !== 'manager') {
        next('/admin/tasks')
        return
      }

      // 主管登录后，若未设置 currentTask，自动根据 task_ids 设置
      if (role === 'manager' && store) {
        const currentTask = store.state.tasks && store.state.tasks.currentTask
        if (!currentTask) {
          const user = store.state.user
          const taskIds = user && user.task_ids ? user.task_ids : []
          if (taskIds.length > 0) {
            store.dispatch('switchTask', taskIds[0])
          }
        }
      }

      // 主管禁止访问后台页面
      if (to.meta && to.meta.adminOnly && role === 'manager') {
        next('/')
        return
      }

      // 任务层路由：初始化 currentTask 并校验权限
      if (to.meta && to.meta.taskLayer) {
        const taskId = to.params.taskId
        if (store && taskId) {
          store.dispatch('initCurrentTask', { taskId })
          // 非超管需校验任务访问权限
          if (role !== 'super_admin') {
            const myTasks = store.getters.myTasks
            const hasAccess = myTasks.some(t => String(t.task_id) === String(taskId))
            if (!hasAccess) {
              const firstTask = myTasks[0]
              if (firstTask) {
                next(`/admin/tasks/${firstTask.task_id}/employees`)
              } else {
                next('/admin/admins')
              }
              return
            }
          }
        }
      }

      // 旧任务层路由：如有 currentTaskId 则重定向到新路由
      const moduleName = legacyTaskRouteMap[to.path]
      if (moduleName) {
        const currentTaskId = store && store.getters.currentTaskId
        if (currentTaskId) {
          next(`/admin/tasks/${currentTaskId}/${moduleName}${to.search}`)
          return
        }
      }

      // 普通管理员访问后台页面：检查菜单权限
      if (to.meta && to.meta.adminOnly && role === 'admin') {
        const permission = to.meta.permission
        if (permission) {
          if (store && !hasPermission(store, permission)) {
            // 无权限，重定向到第一个有权限的页面
            const firstPermitted = findFirstPermittedRoute(store)
            next(firstPermitted || '/')
            return
          }
        }
      }
      // 超管禁止访问前台功能页面（首页除外）
      if (to.meta && to.meta.managerOnly && role === 'super_admin') {
        next('/admin/employees')
        return
      }
      // 普通管理员禁止访问前台功能页面（首页除外）
      if (to.meta && to.meta.managerOnly && role === 'admin') {
        next('/admin/employees')
        return
      }
    }

    next()
  } catch (e) {
    console.error('[Router] 导航守卫异常:', e)
    next('/login')
  }
})

function findFirstPermittedRoute(store) {
  const menuTree = [
    { permission: 'admin:manage', route: '/admin/admins' },
    { permission: 'employee:view', route: '/admin/employees' },
    { permission: 'behavior:view', route: '/admin/behaviors' },
    { permission: 'evaluation:view', route: '/admin/evaluations' },
    { permission: 'instruction:view', route: '/admin/config?tab=instruction' },
    { permission: 'scoring:view', route: '/admin/config?tab=scoring' },
    { permission: 'template:view', route: '/admin/contents' },
    { permission: 'content:view', route: '/admin/contents' },
    { permission: 'departure_feedback:view', route: '/admin/departure-survey' },
    { permission: 'survey:view', route: '/admin/surveys' }
  ]
  for (const item of menuTree) {
    if (hasPermission(store, item.permission)) {
      return item.route
    }
  }
  return null
}

export default router
